import React, { Component } from 'react';
import PopoverWrapper from './PopoverWrapper';
class PopoverUncontrolled extends Component {
    constructor(props) {
        super(props);
        this.togglePopover = () => {
            const { isOpen } = this.state;
            this.setState({ isOpen: !isOpen });
        };
        this.state = {
            isOpen: false,
        };
    }
    render() {
        const { size, className, disabled, trigger, target, placement, autoHide, children } = this.props;
        const { isOpen } = this.state;
        let resultClassName = 'ac-popover ' + (size ? size : 'xl') + ' ' + (className ? className : '');
        return (React.createElement(PopoverWrapper, { target: target, placement: placement, trigger: trigger || 'legacy', isOpen: isOpen, role: 'popover', toggle: this.togglePopover, disabled: disabled, className: resultClassName, autoHide: autoHide || true, children: children }));
    }
}
export default PopoverUncontrolled;
//# sourceMappingURL=PopoverUncontrolled.js.map